"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeButton = void 0;
const typestyle_1 = require("typestyle");
exports.VolumeButton = (0, typestyle_1.stylesheet)({
    button: {
        width: '28px',
        height: '28px',
        padding: '2px',
        marginRight: '5px'
    }
});
